import { ICommand, IDefineCommand, IQuery, IQueryMediator } from 'core-ts-types';
import * as _4 from 'lodash4';
import { AppointmentsCommandServant } from '../servants/appointments_command_servant';

angular
  .module('capability-ng-appointments')
  .factory(
    'dropinAppointmentCommand',
    (
      defineCommand: IDefineCommand,
      log: any,
      QueryMediator: IQueryMediator,
      ngAppointmentsCommandServant: AppointmentsCommandServant
    ): ICommand => {
      return defineCommand(
        'dropinAppointmentCommand',
        (
          deferred: ng.IDeferred<IQuery[]>,
          location_id: number,
          service_id: number,
          care_unit_id: number,
          staff_id: number,
          course_id: number
        ): void => {
          const payload = {
            location_id,
            service_id,
            care_unit_id
          };

          if (staff_id) {
            _4.set(payload, 'staff_id', staff_id);
          }

          if (course_id) {
            _4.set(payload, 'course_id', course_id);
          }

          ngAppointmentsCommandServant
            .request({
              url: 'dropins',
              method: 'POST',
              data: payload
            })
            .then((response: any) => {
              QueryMediator.runQueries();
              deferred.resolve(response);
            })
            .catch((error: any) => {
              log.error('unable to check in first available appointment');
              deferred.reject(error);
            });
        }
      );
    }
  );



// WEBPACK FOOTER //
// ./app/vendor/capability-ng-appointments/src/commands/appointments_dropin_command.ts